import styled, { css } from "styled-components";

import { smallMobileBreakpoint } from "../../styles/breakpoints";

export const Wrapper = styled.button`
  ${({ active }) => css`
    border: 0;
    outline: none;
    background: transparent;
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    transition: filter 0.5s ease-in-out;

    filter: ${!active ? "grayscale(1); color: #6B7280" : "grayscale(0)"};
  `}

  /* Na barra compacta fica só o ícone: o rótulo ocupava a maior parte da
     largura e empurrava as categorias para outras linhas. */
  ${({ compact }) =>
    !!compact &&
    css`
      justify-content: center;
      padding: 0;

      svg,
      img {
        width: 32px;
        height: 32px;
      }

      @media (max-width: ${smallMobileBreakpoint}px) {
        svg,
        img {
          width: 28px;
          height: 28px;
        }
      }
    `}
`;

export const Label = styled.p`
  ${({ theme }) => css`
    font-weight: ${theme.font.normal};
    margin-left: 10px;
    font-size: ${theme.font.sizes.xsmall};
  `}

  ${({ compact }) =>
    !!compact &&
    css`
      display: none;
    `}
`;

export const Icon = styled.img`
  width: 30px;
`;
